import path from 'path';
import {computed} from 'vue';
import {useRoute} from '@nuxtjs/composition-api';

import {useNavigationStore} from '@/stores/navigation';
import {getPath, getMainItems, getOtherItems} from '@/core/utils/menu';

export function useMainMenu() {
    const route = useRoute();
    const navigationStore = useNavigationStore();

    const parentSlug = computed(() => {
        return route.value.path === '/' ? 'for-individuals' : route.value.path.split('/')[1];
    });

    const subMenu = computed(() => {
        return navigationStore.menu?.find((item) => {
            return item.slug === parentSlug.value;
        }) ?? [];
    });

    const getSubItems = computed(() => {
        return subMenu.value?.subMenu || [];
    });

    const subMenuMod = computed(() => {
        return {
            subMenu: [subMenu.value],
        };
    });

    function getLink(item) {
        return item?.path ?? path.normalize(`/${getPath(subMenuMod.value, item.slug)?.join('/')}`);
    }

    function isLinkActive(link) {
        return route.value.path === link;
    }

    function sameLinkEventHandler(link) {
        console.log('link :>> ', link);
        if (route.value.path === link) {
            navigationStore.toggleSubMenu(navigationStore.activeSubMenu);
        }
    }

    return {
        menu: computed(() => navigationStore.menu),
        activeChapter: computed(() => navigationStore.activeChapter),
        activeSubMenu: computed(() => navigationStore.activeSubMenu),
        activeExpandItem: computed(() => navigationStore.activeExpandItem),
        setActiveChapter: navigationStore.setActiveChapter,
        toggleSubMenu: navigationStore.toggleSubMenu,
        toggleExpandItem: navigationStore.toggleExpandItem,
        parentSlug,
        subMenu,
        getSubItems,
        subMenuMod,
        getPath,
        getLink,
        isLinkActive,
        sameLinkEventHandler,
        getMainItems,
        getOtherItems,
    };
};
